import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { Box, Card, Column, Popover, SegmentControl } from 'seagull';
import { ColorPicker } from '~/components/ColorPicker/ColorPicker';
import { ColorSelector } from '~/components/ColorSelector/ColorSelector';
import { PRESET_GRADIENTS, PRESET_SOLID_COLORS } from './brandingPresetColors';
import stylesPrimary from './PrimaryBackgroundColorPopup.module.scss';
export function PrimaryBackgroundColorPopup(props) {
    const { branding, hasError, onChange } = props;
    const start = branding.backgroundGradientStart;
    const end = branding.backgroundGradientEnd;
    const isSolid = start === end;
    const [anchorEl, setAnchorEl] = useState(null);
    const [activeTab, setActiveTab] = useState(isSolid ? 'solid' : 'gradient');
    const displayBackground = isSolid ? start : "linear-gradient(315deg, ".concat(end, " 0%, ").concat(start, " 100%)");
    function applySolid(color) {
        onChange(_object_spread_props(_object_spread({}, branding), {
            backgroundGradientStart: color,
            backgroundGradientEnd: color
        }));
    }
    function applyGradient(color1, color2) {
        onChange(_object_spread_props(_object_spread({}, branding), {
            backgroundGradientStart: color1,
            backgroundGradientEnd: color2
        }));
    }
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(ColorSelector, {
                withBorder: true,
                color: displayBackground,
                hasError: hasError,
                testId: "color-selector-primary-background",
                onClick: (e)=>setAnchorEl(e.currentTarget)
            }),
            /*#__PURE__*/ _jsx(Popover, {
                anchorEl: anchorEl,
                open: !!anchorEl,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'right'
                },
                transformOrigin: {
                    vertical: -5,
                    horizontal: 'right'
                },
                onClose: ()=>setAnchorEl(null),
                children: /*#__PURE__*/ _jsx(Card, {
                    className: stylesPrimary.popupCard,
                    children: /*#__PURE__*/ _jsxs(Column, {
                        gap: 16,
                        alignItems: "stretch",
                        children: [
                            /*#__PURE__*/ _jsx(Box, {
                                className: stylesPrimary.segmentControlWrapper,
                                children: /*#__PURE__*/ _jsx(SegmentControl, {
                                    options: [
                                        {
                                            value: 'gradient',
                                            label: 'Gradient',
                                            testId: 'primary-bg-tab-gradient'
                                        },
                                        {
                                            value: 'solid',
                                            label: 'Solid',
                                            testId: 'primary-bg-tab-solid'
                                        }
                                    ],
                                    value: activeTab,
                                    onChange: (value)=>setActiveTab(value),
                                    variant: "text",
                                    "aria-label": "Primary background type",
                                    testId: "primary-background-segment"
                                })
                            }),
                            activeTab === 'gradient' ? /*#__PURE__*/ _jsxs(Column, {
                                gap: 24,
                                className: stylesPrimary.tabContent,
                                children: [
                                    /*#__PURE__*/ _jsx(Box, {
                                        className: stylesPrimary.gradientGrid,
                                        children: PRESET_GRADIENTS.map((param, idx)=>{
                                            let [c1, c2] = param;
                                            return /*#__PURE__*/ _jsx(ColorSelector, {
                                                withBorder: true,
                                                color: "linear-gradient(315deg, ".concat(c2, " 0%, ").concat(c1, " 100%)"),
                                                selected: start === c1 && end === c2,
                                                testId: "gradient-preset-".concat(idx),
                                                onClick: ()=>applyGradient(c1, c2)
                                            }, "".concat(c1, "-").concat(c2, "-").concat(idx));
                                        })
                                    }),
                                    /*#__PURE__*/ _jsxs(Column, {
                                        gap: 24,
                                        children: [
                                            /*#__PURE__*/ _jsx(ColorPicker, {
                                                colorAsSuffix: true,
                                                className: stylesPrimary.colorPickerFullWidth,
                                                inputWrapperClassName: stylesPrimary.primaryBgColorPickerInputWrapper,
                                                testId: "primary-bg-custom-color-1",
                                                label: "Custom color 1",
                                                color: start,
                                                displayColor: start,
                                                noMinWidth: true,
                                                onChange: (c)=>applyGradient(c, end)
                                            }),
                                            /*#__PURE__*/ _jsx(ColorPicker, {
                                                colorAsSuffix: true,
                                                className: stylesPrimary.colorPickerFullWidth,
                                                inputWrapperClassName: stylesPrimary.primaryBgColorPickerInputWrapper,
                                                label: "Custom color 2",
                                                testId: "primary-bg-custom-color-2",
                                                color: end,
                                                displayColor: end,
                                                noMinWidth: true,
                                                onChange: (c)=>applyGradient(start, c)
                                            })
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ _jsxs(Column, {
                                gap: 24,
                                className: stylesPrimary.tabContent,
                                children: [
                                    /*#__PURE__*/ _jsx(Box, {
                                        className: stylesPrimary.gradientGrid,
                                        children: PRESET_SOLID_COLORS.map((presetColor, idx)=>/*#__PURE__*/ _jsx(ColorSelector, {
                                                withBorder: true,
                                                color: presetColor,
                                                selected: presetColor.toLowerCase() === (start || '').toLowerCase(),
                                                testId: "solid-preset-".concat(idx),
                                                onClick: ()=>applySolid(presetColor)
                                            }, presetColor))
                                    }),
                                    /*#__PURE__*/ _jsx(ColorPicker, {
                                        colorAsSuffix: true,
                                        className: stylesPrimary.colorPickerFullWidth,
                                        inputWrapperClassName: stylesPrimary.primaryBgColorPickerInputWrapper,
                                        testId: "primary-bg-solid-custom",
                                        color: start,
                                        noMinWidth: true,
                                        label: "Custom color",
                                        displayColor: start,
                                        onChange: applySolid
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
}
